module.exports = __webpack_public_path__ + "static/media/card_back.d0c353ad.jpg";